var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms-tracking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-tracking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 21.25H7C6.59 21.25 6.25 20.91 6.25 20.5C6.25 20.09 6.59 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7C4.14 4.25 2.75 5.64 2.75 8.5C2.75 8.91 2.41 9.25 2 9.25C1.59 9.25 1.25 8.91 1.25 8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0027 12.87C11.1627 12.87 10.3127 12.61 9.66271 12.08L6.53271 9.57997C6.21271 9.31997 6.15271 8.84997 6.41271 8.52997C6.67271 8.20997 7.1427 8.14997 7.4627 8.40997L10.5927 10.91C11.3527 11.52 12.6427 11.52 13.4027 10.91L16.5327 8.40997C16.8527 8.14997 17.3327 8.19997 17.5827 8.52997C17.8427 8.84997 17.7927 9.32997 17.4627 9.57997L14.3327 12.08C13.6927 12.61 12.8427 12.87 12.0027 12.87Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 17.25H2C1.59 17.25 1.25 16.91 1.25 16.5C1.25 16.09 1.59 15.75 2 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5 13.25H2C1.59 13.25 1.25 12.91 1.25 12.5C1.25 12.09 1.59 11.75 2 11.75H5C5.41 11.75 5.75 12.09 5.75 12.5C5.75 12.91 5.41 13.25 5 13.25Z",
    fill: "#053CC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsck);
export default __webpack_public_path__ + "static/media/smsck.42cce8b9f54dd8393682f7879a320e38.svg";
export { ForwardRef as ReactComponent };